/* eslint-disable */
// GENERATED FILE - DO NOT EDIT
import React, { SVGProps } from "react";

const SvgQaQualityAssurance = (props: SVGProps<SVGSVGElement>) => (
  <svg width={27.774} viewBox="0 0 27.774 27.715" {...props}>
    <g data-name="QA Quality Assurance">
      <path
        data-name="Path 788"
        d="M19.633 6.189A5.783 5.783 0 1113.851.407a5.782 5.782 0 015.782 5.782z"
        fill="#12b05e"
      />
      <path
        data-name="Path 789"
        d="M13.852.407a5.838 5.838 0 00-.678.04 5.782 5.782 0 010 11.483A5.782 5.782 0 1013.852.407z"
        fill="#03984b"
      />
      <path
        data-name="Path 790"
        d="M9.488 9.981l-1.987 4.083 2.826-.5 1.352 2.531 2.01-4.13a5.768 5.768 0 01-4.201-1.984z"
        fill="#fb6672"
      />
      <path
        data-name="Path 791"
        d="M12.452 11.798l-1.475 2.982.7 1.317 2.01-4.13a5.79 5.79 0 01-1.235-.169z"
        fill="#fb4a59"
      />
      <path
        data-name="Path 792"
        d="M18.215 9.981a5.768 5.768 0 01-4.2 1.986l2.01 4.13 1.352-2.531 2.826.5z"
        fill="#fb6672"
      />
      <path
        data-name="Path 793"
        d="M18.719 13.803l1.483.261-1.987-4.083a5.814 5.814 0 01-.936.863z"
        fill="#fb4a59"
      />
      <path
        data-name="Path 794"
        d="M13.605 3.539l-.651 1.319a.275.275 0 01-.207.15l-1.456.212a.275.275 0 00-.152.468l1.054 1.027a.275.275 0 01.079.243l-.249 1.45a.275.275 0 00.4.29l1.3-.685a.274.274 0 01.256 0l1.3.685a.275.275 0 00.4-.29l-.249-1.45a.275.275 0 01.079-.243l1.054-1.027a.275.275 0 00-.152-.468l-1.456-.212a.275.275 0 01-.207-.15l-.651-1.319a.275.275 0 00-.492 0z"
        fill="#ffcd27"
      />
      <path
        data-name="Path 795"
        d="M19.04 20.49a1.109 1.109 0 01-.97 1.1l-6.9.873 2.931.353a13.091 13.091 0 007.916-1.551l2.685-1.49a1.001 1.001 0 00-.952-1.762l-4.708 2.477z"
        fill="#f7b081"
      />
      <path
        data-name="Path 796"
        d="M24.697 19.776a1 1 0 00.424-1.292l-6.413 3.431-2.375-.1-5.168.653 2.931.353a13.09 13.09 0 007.916-1.551z"
        fill="#db9975"
      />
      <g data-name="Group 257" fill="#f7b081">
        <path
          data-name="Path 797"
          d="M17.931 19.38a1.109 1.109 0 011.109 1.109l2.614-1.376a.99.99 0 00.386-1.383.99.99 0 00-1.318-.358l-3.719 2.013h.928z"
        />
        <path
          data-name="Path 798"
          d="M12.485 19.381l5.4-2.827a1.033 1.033 0 011.312.3 1.033 1.033 0 01-.34 1.522l-1.853 1z"
        />
      </g>
      <path
        data-name="Path 799"
        d="M3.36 21.075a11.1 11.1 0 014.523-2.171 8.538 8.538 0 014.6.476h5.446a1.109 1.109 0 011.109 1.109 1.109 1.109 0 01-.97 1.1l-6.9.873 2.931.353a13.091 13.091 0 007.916-1.551l3.667-2.035a1.15 1.15 0 011.453.324 1.15 1.15 0 01-.368 1.7l-5.358 2.921c-2.688 1.462-5.748 3.379-8.8 3.108l-9.248-.824H.409v-5.383h2.953z"
        fill="#ffc89f"
      />
      <path
        data-name="Path 800"
        d="M27.136 19.555c-.023-.031-.048-.059-.073-.087a1.143 1.143 0 01-.554.69l-5.363 2.917c-2.688 1.462-5.748 3.379-8.8 3.108l-9.248-.824H.409v1.1h2.953l9.248.824c3.048.272 6.108-1.645 8.8-3.108l5.363-2.917a1.149 1.149 0 00.363-1.703z"
        fill="#f7b081"
      />
      <g data-name="Group 258" fill="#db9975">
        <path
          data-name="Path 801"
          d="M17.004 19.381l1.853-1a1.034 1.034 0 00.459-1.315l-4.235 2.318z"
        />
        <path
          data-name="Path 802"
          d="M19.04 20.49l2.614-1.375a.99.99 0 00.479-1.185l-3.4 1.8a1.1 1.1 0 01.307.76z"
        />
      </g>
      <path
        data-name="Path 803"
        d="M17.021 5.282a.677.677 0 00-.55-.464l-1.387-.2-.62-1.257a.677.677 0 00-.611-.38.677.677 0 00-.611.38l-.62 1.257-1.388.2a.681.681 0 00-.378 1.162l1 .979-.237 1.382a.681.681 0 00.989.718l1.241-.652 1.241.652a.681.681 0 00.989-.718l-.237-1.382 1-.979a.677.677 0 00.179-.698zm-1.794 1.143a.681.681 0 00-.2.6l.2 1.187-1.065-.56a.681.681 0 00-.634 0l-1.066.56.2-1.187a.681.681 0 00-.2-.6l-.862-.84 1.191-.173a.681.681 0 00.513-.373l.533-1.08.533 1.079a.681.681 0 00.513.373l1.191.173z"
      />
      <path
        data-name="Path 804"
        d="M7.572 14.464l2.536-.446 1.213 2.271a.407.407 0 00.359.215h.008a.407.407 0 00.358-.229l1.807-3.712 1.806 3.712a.407.407 0 00.358.229h.008a.407.407 0 00.359-.215l1.214-2.271 2.536.446a.407.407 0 00.436-.579l-1.874-3.849A6.187 6.187 0 0010.529.967a.407.407 0 00.438.686 5.374 5.374 0 115.7 9.112l-.031.019a5.38 5.38 0 01-2.485.769h-.007l-.136.006h-.307l-.137-.006h-.006a5.38 5.38 0 01-2.484-.768l-.026-.016a5.373 5.373 0 01-1.247-8.107.407.407 0 00-.614-.534 6.182 6.182 0 00-.173 7.909L7.14 13.886a.407.407 0 00.436.579zm9.875-1.3a.407.407 0 00-.429.209l-.977 1.828-1.4-2.876a6.146 6.146 0 002.472-.876l.056-.035.144-.094.108-.075.028-.02a6.188 6.188 0 00.659-.54l1.383 2.842zm-7.848-2.483a6.183 6.183 0 00.659.54l.027.02.109.075q.071.048.143.094l.056.035a6.147 6.147 0 002.469.879l-1.4 2.876-.977-1.828a.407.407 0 00-.429-.209l-2.041.359z"
      />
      <path
        data-name="Path 805"
        d="M18.878 25.093c-1.88.99-4.09 1.977-6.234 1.785L3.4 26.054H.813v-4.569H3.36a.407.407 0 00.262-.1 11.3 11.3 0 012.364-1.444.407.407 0 00-.336-.741 12.318 12.318 0 00-2.434 1.468H.407a.407.407 0 00-.407.408v5.383a.407.407 0 00.407.407h2.935l9.23.823q.31.028.619.027a13.532 13.532 0 006.066-1.9.407.407 0 10-.379-.72z"
      />
      <path
        data-name="Path 806"
        d="M27.46 19.309a1.55 1.55 0 00-1.84-.5 1.407 1.407 0 00-2.061-1.158l-.971.511a1.4 1.4 0 00-2.059-1.154l-.726.393a1.44 1.44 0 00-2.107-1.21l-5.232 2.74a8.967 8.967 0 00-4.655-.428c-.162.03-.328.066-.493.108a.407.407 0 10.2.789c.149-.037.3-.07.444-.1a8.2 8.2 0 014.362.447l.025.01h.01a.4.4 0 00.057.015h.013a.4.4 0 00.061.005h5.446a.701.701 0 01.088 1.4l-6.9.873a.407.407 0 000 .807l2.931.353.241.027.074.007.172.016.079.007.191.014h.052l.235.012h.075l.166.005H16.247l.147-.007.1-.006.148-.01.093-.007.2-.017.076-.007.194-.02.093-.011.146-.018.1-.013.144-.021.1-.014.173-.029.063-.011.227-.042.088-.018.148-.03.1-.021.142-.032.094-.022.163-.04.07-.018.225-.06.078-.022.154-.045.091-.028.143-.045.09-.029.157-.052.072-.024.223-.079.061-.023.166-.063.084-.033.145-.058.085-.035.153-.065.071-.031.219-.1.038-.018.183-.086.075-.036.148-.073.079-.04.15-.078.069-.036.216-.117 3.663-2.033a.744.744 0 01.7 1.312l-5.363 2.917c-.272.148-.547.3-.826.455l-.057.032a.407.407 0 10.394.712l.057-.032c.277-.153.551-.3.821-.452l5.363-2.917a1.556 1.556 0 00.5-2.305zm-6.544-1.584a.583.583 0 11.549 1.029l-.9.471-1.249.657-.01-.022-.018-.039-.015-.029-.02-.038-.016-.028-.022-.037-.018-.027-.024-.036-.019-.027-.025-.034-.02-.026-.027-.033-.021-.025-.029-.031-.022-.023-.031-.03-.023-.022-.032-.029-.024-.021-.034-.027-.025-.019-.036-.026-.024-.017-.04-.026-.023-.015-.047-.027-.019-.011q-.066-.036-.137-.066l-.018-.007-.053-.021.605-.328zm-2.843-.812a.627.627 0 01.589 1.106l-1.762.953h-2.762zm.048 5.08c.038 0 .076-.011.113-.019h.016q.053-.011.1-.026l.02-.006q.051-.015.1-.034l.017-.007c.033-.013.066-.027.1-.043h.008q.047-.023.093-.05l.011-.006c.03-.018.06-.037.088-.057l.016-.011q.042-.03.082-.062l.014-.012c.027-.022.053-.046.078-.07l.009-.009q.038-.037.073-.077c.024-.027.046-.055.068-.083l.01-.013q.031-.041.059-.085l.01-.016c.019-.029.036-.059.053-.09l.007-.013a1.389 1.389 0 00.088-.2l.005-.014c.011-.033.021-.067.03-.1l.005-.019c.008-.034.016-.068.022-.1v-.008l4.512-2.374a.6.6 0 01.761.18.595.595 0 01-.2.866l-2.685 1.49a12.6 12.6 0 01-7.308 1.541z"
      />
    </g>
  </svg>
);

SvgQaQualityAssurance.defaultProps = {};
export default SvgQaQualityAssurance;
/* eslint-enable */
